<button class="scroll-button" (click)="scrollToTop()" title="Go to top" *ngIf="showScrollToTop$ | async"><i class="arrow up"></i></button>
